import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import {
  LandscapeOutlined, VideocamOutlined, OndemandVideoOutlined, StorefrontOutlined,
  MeetingRoomOutlined, SportsEsportsOutlined, ViewComfyOutlined,
  AutoAwesomeOutlined, PhotoLibraryOutlined, CloseOutlined, CheckCircleOutlined,
} from '@mui/icons-material';
import { PRIMARY } from '../constants';
import { ContentBrowserModal } from '../ContentBrowserModal';

// ── Template data ─────────────────────────────────────────────────────────────
export const LOBBY_TEMPLATES = [
  { id: 'lobby-2',      label: 'Mid-Size Lobby 1',      category: 'lobby',      type: 'video', url: 'https://res.cloudinary.com/dasne3x79/video/upload/v1777817010/lobbyA.mp4',      thumb: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777875648/hf_20260429_063513_fb42eaf6-8073-47bb-8aab-07feceadde93.png' },
  { id: 'lobby-3',      label: 'Masive Lobby',      category: 'lobby',      type: 'image', url: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777875731/hf_20260429_064732_c17f2d2e-a62d-4edc-96ed-c47919866312.png',      thumb: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777875731/hf_20260429_064732_c17f2d2e-a62d-4edc-96ed-c47919866312.png' },
  { id: 'lobby-4',      label: '2 Door Lobby 1',      category: 'lobby',      type: 'image', url: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777875740/hf_20260420_074012_a0b6c3ee-b881-45bb-b534-52f4b6cdc527.png',      thumb: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777875740/hf_20260420_074012_a0b6c3ee-b881-45bb-b534-52f4b6cdc527.png' },

  { id: 'plenary-1',    label: 'Theater Hall 1',      category: 'plenary',    type: 'image', url: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777876074/hf_20260420_102739_8524d534-df6d-4a80-b5d4-fa1d48aa83ed.png',      thumb: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777876074/hf_20260420_102739_8524d534-df6d-4a80-b5d4-fa1d48aa83ed.png' },
  { id: 'plenary-2',    label: 'Japandi Hall',        category: 'plenary',    type: 'image', url: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777876075/hf_20260420_102358_ee30d8e6-ec3e-40f0-999e-b49fc9744741.png',      thumb: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777876075/hf_20260420_102358_ee30d8e6-ec3e-40f0-999e-b49fc9744741.png' },
  { id: 'exhibition-1', label: 'Bright Exhibition',   category: 'exhibition', type: 'image', url: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777877458/hf_20260504_064915_ba2f9b21-b9dd-4fd8-ae21-f0d8779d375d.png', thumb: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777877458/hf_20260504_064915_ba2f9b21-b9dd-4fd8-ae21-f0d8779d375d.png' },
  { id: 'exhibition-2', label: 'Simple Exhibition',  category: 'exhibition', type: 'image', url: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777877908/hf_20260504_065721_96c0dcf0-4a90-4326-9d80-50ece170557c.png', thumb: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777877908/hf_20260504_065721_96c0dcf0-4a90-4326-9d80-50ece170557c.png' },
  { id: 'arcade-1',     label: 'Arcade Room',       category: 'arcade',     type: 'image', url: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777876021/hf_20260429_123238_566adf9a-8b18-46aa-afc2-8f7133854191.png',      thumb: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777876021/hf_20260429_123238_566adf9a-8b18-46aa-afc2-8f7133854191.png' },
  { id: 'booth-1',     label: 'Simple Booth',         category: 'booth',     type: 'image', url: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777876580/hf_20260421_082209_318fb4df-af51-412b-9bb1-2c0ad078380b.png',      thumb: 'https://res.cloudinary.com/dasne3x79/image/upload/v1777876580/hf_20260421_082209_318fb4df-af51-412b-9bb1-2c0ad078380b.png' },
];

export const TEMPLATE_CATEGORIES = [
  { key: 'all',        label: 'All',             icon: <ViewComfyOutlined sx={{ fontSize: 13 }} /> },
  { key: 'lobby',      label: 'Lobby',           icon: <MeetingRoomOutlined sx={{ fontSize: 13 }} /> },
  { key: 'plenary',    label: 'Plenary',         icon: <OndemandVideoOutlined sx={{ fontSize: 13 }} /> },
  { key: 'exhibition', label: 'Exhibition Hall', icon: <StorefrontOutlined sx={{ fontSize: 13 }} /> },
  { key: 'arcade',     label: 'Arcade Room',     icon: <SportsEsportsOutlined sx={{ fontSize: 13 }} /> },
  { key: 'booth',     label: 'Exhibitor Booths ', icon: <StorefrontOutlined sx={{ fontSize: 13 }} /> },
];

export const CATEGORY_LABELS = {
  lobby: 'Lobby', plenary: 'Plenary', exhibition: 'Exhibition Hall', arcade: 'Arcade Room', booth: 'Exhibitor Booths',
};

// ── LobbyTemplateBrowser ──────────────────────────────────────────────────────
export function LobbyTemplateBrowser({ open, onClose, onSelect }) {
  const [filter,   setFilter]   = useState('all');
  const [selected, setSelected] = useState(null);

  const filtered = filter === 'all' ? LOBBY_TEMPLATES : LOBBY_TEMPLATES.filter(t => t.category === filter);
  const grouped = {};
  filtered.forEach(t => { if (!grouped[t.category]) grouped[t.category] = []; grouped[t.category].push(t); });
  const orderedCategories = ['lobby', 'plenary', 'exhibition', 'booth', 'arcade'].filter(c => grouped[c]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <Box
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      sx={{ position: 'fixed', inset: 0, zIndex: 3000, background: 'rgba(10,15,30,0.65)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}
    >
      <Box sx={{ background: '#fff', borderRadius: 3, width: '100%', maxWidth: 860, maxHeight: '85vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 24px 60px rgba(0,0,0,0.28)' }}>
        <Box sx={{ px: 3, py: 2.5, borderBottom: '1px solid #f0f2f5', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
          <Box>
            <Typography sx={{ fontSize: '1rem', fontWeight: 800, color: '#1a1a2e' }}>Choose a Background Template</Typography>
            <Typography sx={{ fontSize: '0.75rem', color: '#9ea8b3', mt: 0.25 }}>Click an image or video to select, then confirm.</Typography>
          </Box>
          <Box onClick={onClose} sx={{ width: 32, height: 32, borderRadius: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#9ea8b3', '&:hover': { background: '#f0f2f5', color: '#1a1a2e' } }}>
            <CloseOutlined sx={{ fontSize: 18 }} />
          </Box>
        </Box>

        <Box sx={{ px: 3, py: 1.5, borderBottom: '1px solid #f0f2f5', display: 'flex', gap: 0.75, flexShrink: 0, overflowX: 'auto' }}>
          {TEMPLATE_CATEGORIES.map(cat => (
            <Box key={cat.key} onClick={() => setFilter(cat.key)}
              sx={{ display: 'flex', alignItems: 'center', gap: 0.5, px: 1.25, py: 0.5, borderRadius: '999px', cursor: 'pointer', fontSize: '0.75rem', fontWeight: 600, whiteSpace: 'nowrap', border: `1.5px solid ${filter === cat.key ? PRIMARY : '#e4e9f0'}`, background: filter === cat.key ? alpha(PRIMARY, 0.08) : '#f8f9fb', color: filter === cat.key ? PRIMARY : '#7a8494', transition: 'all 0.12s', '&:hover': { borderColor: PRIMARY, color: PRIMARY } }}>
              {cat.icon}{cat.label}
            </Box>
          ))}
        </Box>

        <Box sx={{ flex: 1, overflowY: 'auto', px: 3, py: 2 }}>
          {orderedCategories.map(cat => (
            <Box key={cat} sx={{ mb: 3 }}>
              <Typography sx={{ fontSize: '0.68rem', fontWeight: 700, color: '#9ea8b3', textTransform: 'uppercase', letterSpacing: '0.08em', mb: 1.25 }}>
                {CATEGORY_LABELS[cat]}
              </Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 1.5 }}>
                {grouped[cat].map(tpl => {
                  const isSel = selected?.id === tpl.id;
                  return (
                    <Box key={tpl.id} onClick={() => setSelected(tpl)}
                      sx={{ borderRadius: 2, overflow: 'hidden', cursor: 'pointer', border: `2px solid ${isSel ? PRIMARY : '#e4e9f0'}`, boxShadow: isSel ? `0 0 0 3px ${alpha(PRIMARY, 0.2)}` : 'none', transition: 'all 0.15s', position: 'relative', '&:hover': { borderColor: PRIMARY, transform: 'translateY(-2px)', boxShadow: `0 4px 16px ${alpha(PRIMARY, 0.15)}` } }}>
                      <Box sx={{ height: 110, background: '#f0f4f8', position: 'relative', overflow: 'hidden' }}>
                        {tpl.type === 'video' ? (
                          <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1a1a2e' }}>
                            <VideocamOutlined sx={{ fontSize: 32, color: 'rgba(255,255,255,0.4)' }} />
                          </Box>
                        ) : (
                          <Box component="img" src={tpl.thumb || tpl.url} alt={tpl.label} sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                        )}
                        {isSel && (
                          <Box sx={{ position: 'absolute', top: 6, right: 6, width: 22, height: 22, borderRadius: '50%', background: PRIMARY, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <CheckCircleOutlined sx={{ fontSize: 14, color: '#fff' }} />
                          </Box>
                        )}
                        {tpl.type === 'video' && (
                          <Box sx={{ position: 'absolute', bottom: 4, left: 4, px: 0.75, py: 0.2, background: 'rgba(0,0,0,0.6)', borderRadius: 0.75, display: 'flex', alignItems: 'center', gap: 0.4 }}>
                            <VideocamOutlined sx={{ fontSize: 10, color: '#fff' }} />
                            <Typography sx={{ fontSize: '0.58rem', color: '#fff', fontWeight: 700 }}>VIDEO</Typography>
                          </Box>
                        )}
                      </Box>
                      <Box sx={{ px: 1.25, py: 0.875, background: '#fff' }}>
                        <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#1a1a2e', lineHeight: 1.2 }}>{tpl.label}</Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          ))}
        </Box>

        <Box sx={{ px: 3, py: 2, borderTop: '1px solid #f0f2f5', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0, background: '#fafbfc' }}>
          <Typography sx={{ fontSize: '0.75rem', color: '#9ea8b3' }}>
            {selected ? `Selected: ${selected.label}` : 'No template selected'}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Box onClick={onClose} sx={{ px: 2, py: 0.85, borderRadius: 1.5, border: '1px solid #e4e9f0', background: '#fff', fontSize: '0.8rem', fontWeight: 600, color: '#5a6474', cursor: 'pointer', '&:hover': { background: '#f0f2f5' } }}>Cancel</Box>
            <Box onClick={() => { if (selected) { onSelect(selected); onClose(); } }}
              sx={{ px: 2.5, py: 0.85, borderRadius: 1.5, background: selected ? PRIMARY : '#e4e9f0', color: selected ? '#fff' : '#b0bac8', fontSize: '0.8rem', fontWeight: 700, cursor: selected ? 'pointer' : 'default', transition: 'all 0.15s', '&:hover': selected ? { opacity: 0.9 } : {} }}>
              Use this background
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>,
    document.body
  );
}

// ── LobbyWizard ───────────────────────────────────────────────────────────────
export function LobbyWizard({ onUpdateLobby, onCreateLobby }) {
  const [templateBrowserOpen, setTemplateBrowserOpen] = useState(false);
  const [contentBrowserOpen,  setContentBrowserOpen]  = useState(false);

  const handleTemplateSelect = (tpl) => {
    const patch = { bgUrl: tpl.url, bgType: tpl.type || 'image' };
    if (onCreateLobby) {
      onCreateLobby({
        name: tpl.label || 'New Lobby',
        slug: (tpl.label || 'new-lobby').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') + `-${Date.now().toString(36)}`,
        isDefault: true, isActive: true,
        bgType: patch.bgType, bgUrl: patch.bgUrl,
        showIntro: false, introVideoUrl: null,
        transitionVideoUrl: null, returnVideoUrl: null,
        lobbyType: 'lobby', hotspots: [], elements: [],
      });
    } else {
      onUpdateLobby?.(patch);
    }
  };

  const handleContentSelect = (url, asset) => {
    const isVideo = asset?.mediaType === 'video' || /\.(mp4|webm|ogg|mov)(\?|$)/i.test(url);
    const patch = { bgUrl: url, bgType: isVideo ? 'video' : 'image' };
    if (onCreateLobby) {
      onCreateLobby({
        name: 'New Lobby',
        slug: `lobby-${Date.now().toString(36)}`,
        isDefault: true, isActive: true,
        bgType: patch.bgType, bgUrl: patch.bgUrl,
        showIntro: false, introVideoUrl: null,
        transitionVideoUrl: null, returnVideoUrl: null,
        lobbyType: 'lobby', hotspots: [], elements: [],
      });
    } else {
      onUpdateLobby?.(patch);
    }
    setContentBrowserOpen(false);
  };

  return (
    <>
      <Box
        sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3, p: 4 }}
        onClick={e => e.stopPropagation()}
      >
        <Box sx={{ textAlign: 'center', mb: 1 }}>
          <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, borderRadius: '12px', background: alpha(PRIMARY, 0.15), mb: 1.5 }}>
            <LandscapeOutlined sx={{ fontSize: 22, color: '#fff' }} />
          </Box>
          <Typography sx={{ fontSize: '1.3rem', fontWeight: 800, color: '#fff', lineHeight: 1.2, textShadow: '0 2px 12px rgba(0,0,0,0.5)' }}>
            Set a background
          </Typography>
          <Typography sx={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)', mt: 0.75 }}>
            Choose a template or upload from your content library
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2.5, width: '100%', maxWidth: 560 }}>
          <Box
            onClick={() => setTemplateBrowserOpen(true)}
            sx={{
              flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
              gap: 1.5, p: 3, borderRadius: 3, cursor: 'pointer',
              background: 'rgba(255,255,255,0.1)', border: '2px solid rgba(255,255,255,0.2)',
              backdropFilter: 'blur(8px)',
              transition: 'all 0.18s',
              '&:hover': { background: 'rgba(255,255,255,0.18)', border: `2px solid ${alpha(PRIMARY, 0.7)}`, transform: 'translateY(-3px)', boxShadow: `0 8px 32px rgba(0,0,0,0.3)` },
            }}
          >
            <Box sx={{ width: 52, height: 52, borderRadius: 2, background: alpha(PRIMARY, 0.3), display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <AutoAwesomeOutlined sx={{ fontSize: 26, color: '#fff' }} />
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontSize: '0.875rem', fontWeight: 700, color: '#fff', mb: 0.4 }}>Browse Templates</Typography>
              <Typography sx={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.6)', lineHeight: 1.4 }}>
                Choose from curated lobby, plenary, exhibition hall and arcade backgrounds
              </Typography>
            </Box>
            <Box sx={{ px: 2, py: 0.75, borderRadius: 2, background: PRIMARY, color: '#fff', fontSize: '0.75rem', fontWeight: 700 }}>
              Open template library
            </Box>
          </Box>

          <Box
            onClick={() => setContentBrowserOpen(true)}
            sx={{
              flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
              gap: 1.5, p: 3, borderRadius: 3, cursor: 'pointer',
              background: 'rgba(255,255,255,0.08)', border: '2px dashed rgba(255,255,255,0.25)',
              backdropFilter: 'blur(8px)',
              transition: 'all 0.18s',
              '&:hover': { background: 'rgba(255,255,255,0.14)', borderColor: 'rgba(255,255,255,0.5)', transform: 'translateY(-3px)', boxShadow: `0 8px 32px rgba(0,0,0,0.3)` },
            }}
          >
            <Box sx={{ width: 52, height: 52, borderRadius: 2, background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <PhotoLibraryOutlined sx={{ fontSize: 26, color: 'rgba(255,255,255,0.7)' }} />
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontSize: '0.875rem', fontWeight: 700, color: '#fff', mb: 0.4 }}>Content Library</Typography>
              <Typography sx={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.6)', lineHeight: 1.4 }}>
                Pick or upload an image or video from your own content library
              </Typography>
            </Box>
            <Box sx={{ px: 2, py: 0.75, borderRadius: 2, border: '1.5px solid rgba(255,255,255,0.3)', color: '#fff', fontSize: '0.75rem', fontWeight: 700 }}>
              Browse content library
            </Box>
          </Box>
        </Box>
      </Box>

      <LobbyTemplateBrowser open={templateBrowserOpen} onClose={() => setTemplateBrowserOpen(false)} onSelect={handleTemplateSelect} />
      <ContentBrowserModal open={contentBrowserOpen} onClose={() => setContentBrowserOpen(false)} onSelect={handleContentSelect} mediaType="all" />
    </>
  );
}
